import type { MouseEvent } from 'react';
import Image from 'next/image';

import type { CategoryNavigationTile } from '../types';

import styles from './CategoryTile.module.scss';

export interface CategoryTileProps extends CategoryNavigationTile {
  /** Skips lazy loading for the tiles that are on screen on arrival. */
  priority?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  onAuxClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

/**
 * The Figma "Product Category Tile" (vertical): a product cut-out above a
 * centred label. The whole tile is one `<a>`, so there is exactly one tab stop
 * per category and the label is the link's accessible name.
 */
const CategoryTile = ({
  label,
  href,
  image,
  priority = false,
  onClick,
  onAuxClick,
}: CategoryTileProps) => (
  <a
    href={href}
    className={styles.tile}
    onClick={onClick}
    onAuxClick={onAuxClick}
  >
    <span className={styles.imageArea}>
      <span className={styles.imageContainer}>
        <Image
          src={image.url}
          alt={image.alt}
          fill
          // Mobile tiles are a third of a 390px frame; desktop tops out at a
          // sixth of 1376px, with the image inset 24px on each side.
          sizes="(min-width: 988px) 180px, 105px"
          priority={priority}
          className={styles.image}
        />
      </span>
    </span>
    <span className={styles.label}>{label}</span>
  </a>
);

export default CategoryTile;
